var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"m-l-5",attrs:{"size":"sm","variant":"outline-primary"},on:{"click":function($event){$event.stopPropagation();return _vm.ver.apply(null, arguments)}}},[_c('i',{staticClass:"icon-dolar"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }